import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineLargeButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_LARGE_OUTLINE_BUTTONS, RAISED_LARGE_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedOutlineLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineLargeButton} span={RAISED_LARGE_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" outline color="primary" id="Tooltip-54" className="btn-pill btn-air-primary">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-54" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-lg btn-air-primary</ToolTip>
          {RAISED_LARGE_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} outline size="lg"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedOutlineLargeButtons;
